import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { AxiosPromise, AxiosRequestConfig } from 'axios'
import { ResponseData } from 'request'
import {
  AppInfo,
  ProjectQuery,
  ProjectListResponseData,
  MaterialListResponseData,
  CountryListResponseData,
  AsyncJob,
  FileTranscodeData,
} from './index.type'
import { cookRequestParams } from '@/common/request'
import { _Response } from '../type'
import { AiTaskStatus } from '@com/components/text-to-audio/enums'

/**
 * getAppInfo
 * @param params {{app_url: string}}
 * @returns {AxiosPromise}
 */
export function getAppInfo({
  params,
}: {
  params: { app_url: string }
}): AxiosPromise<ResponseData<AppInfo>> {
  return request({
    url: `${v2Host}/common/app`,
    method: 'get',
    params: params,
  })
}

/**
 * 项目搜索
 * @param ProjectQuery
 * @returns ProjectListResponseData
 */
export function getProject(
  params: ProjectQuery,
  options: AxiosRequestConfig = {},
): AxiosPromise<ResponseData<ProjectListResponseData>> {
  return request({
    url: `${v2Host}/common/search/project`,
    method: 'get',
    params: cookRequestParams(params),
    ...options,
  })
}

export function getMaterialList(
  params: any,
): _Response<MaterialListResponseData> {
  return request({
    url: `${v2Host}/common/search/mid`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function getCountryList(): _Response<CountryListResponseData> {
  return request({
    url: `${v2Host}/common/country/list`,
    method: 'get',
  })
}

export function getCommonSearchOptions(params: {
  keyword?: string
  search_field: string
  type: 'billing' | 'download_history'
  page_size: number
}): _Response<any> {
  return request({
    url: `${v2Host}/common/search/options`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export const queryTask = (
  ids?: (string | number)[],
): _Response<{ status: AiTaskStatus; result: string }[] | null> =>
  request(`${v2Host}/async/query`, {
    params: {
      ids: ids?.toString() ?? '',
    },
  })

/**
 * 获取异步任务列表
 * @returns
 */
export function getAsyncJobs(
  options: AxiosRequestConfig = {},
): _Response<AsyncJob[] | null> {
  return request({
    url: `${v2Host}/async/jobs`,
    method: 'get',
    ...options,
  })
}

export function updateAsyncRead(ids: AsyncJob['id'][]): _Response<any> {
  return request({
    url: `${v2Host}/async/read`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ids,
    },
  })
}

/**
 * 文件码转
 */
export function fileTranscode(
  data: FileTranscodeData,
): AxiosPromise<ResponseData<number>> {
  return request({
    url: `${v2Host}/common/transcode `,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}
